import classnamesUndefined from "classnames"

const classnames = (...args) => classnamesUndefined(...args) || undefined

export default classnames
